import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useVentaEnLineaCountdown } from "../../../../hooks/useVentaEnLineaCountdown"

import "./VentaEnLinea.css"

const VentaEnLinea = ({
    roomNumber,
    roomTypeName,
    occupiedTimeStart,
    hasIncidences,
    ventaEnLineaCodigo,
    occupiedTimeEndCondensada,
}: RoomStatusProps) => {
    const { timeLeft, isExceeded } = useVentaEnLineaCountdown(occupiedTimeStart, occupiedTimeEndCondensada)

    return (
        <Wrapper>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                iconBgColor="var(--purple-drawer-primario)"
                iconName="DoorOpenNew"
                roomTypeAbbreviation={roomTypeName?.[0]}
            ></RoomCardHeader>
            <RoomCardBody>
                {isExceeded ? (
                    <>
                        <span className="room-card--sm--venta-en-linea__label">Venta en línea</span>
                        <span className="room-card--sm--venta-en-linea__no-show">No show</span>
                    </>
                ) : (
                    <>
                        <span className="room-card--sm--venta-en-linea__timer">{timeLeft}</span>
                        <span className="room-card--sm--venta-en-linea__codigo">
                            Código: {ventaEnLineaCodigo || "-"}
                        </span>
                    </>
                )}
            </RoomCardBody>
        </Wrapper>
    )
}

export default VentaEnLinea
